export const renderRowNumberPaginated = ({
  pageIndex,
  page,
  pageSize,
}: {
  page: number
  pageIndex: number
  pageSize: number
}) => (page - 1) * pageSize + (pageIndex + 1)
